module.exports = __webpack_public_path__ + "media/images/subscription-promo-desktop-957689e13b94dff1fc8569c92bc985f5.png";